var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractModalContentComponent } from '../../common/modal/abstract-modal-content.component';
import { ModalService } from '../../common/modal/modal.indra.service';
import * as OptionsBarActions from '@ibe/store/actions/options-bar.actions';
import { Store } from '@ngrx/store';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import scrollLock from 'scroll-lock';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import * as UserActions from '@ibe/store/actions/user.actions';
// import * as ModalActions from '@ibe/store/actions/modal.actions';
// import { Observable } from 'rxjs';
// import { takeWhile } from 'rxjs/operators';
import * as DeepLinkPriceMismatchActions from '@ibe/store/actions/deeplink-price-mismatch.actions';
var INDRASessionTimeoutModalComponent = /** @class */ (function (_super) {
    __extends(INDRASessionTimeoutModalComponent, _super);
    // Corp
    // isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
    // isCorporate: boolean;
    // isAlive: boolean = true;
    function INDRASessionTimeoutModalComponent(modalService, route, router, sidebarService, store, api, storageService) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.route = route;
        _this.router = router;
        _this.sidebarService = sidebarService;
        _this.store = store;
        _this.api = api;
        _this.storageService = storageService;
        _this.htmlElement = document.getElementsByTagName('html');
        _this.TYPE = 'dialog';
        _this.CLOSABLE = false; // removed in post-sprint 8 client code delivery
        return _this;
        // this.store.dispatch(new ModalActions.PutShowCloseAction(false));
        /*
        this.isCorporate$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                this.isCorporate = value;
            });
        */
    }
    INDRASessionTimeoutModalComponent.prototype.ngOnDestroy = function () {
        // this.isAlive = false;
    };
    INDRASessionTimeoutModalComponent.prototype.ngOnInit = function () {
        this.store.dispatch(new DeepLinkPriceMismatchActions.ResetAction());
    };
    INDRASessionTimeoutModalComponent.prototype.INDRA_goToBookingsList = function () {
        this.modalService.close();
        this.router.navigate(['my-bookings']);
    };
    INDRASessionTimeoutModalComponent.prototype.closeModal = function () {
        if (this.htmlElement[0].classList.contains('no-scroll')) {
            if (this.router.url.indexOf('sidebar') < 0) {
                this.htmlElement[0].classList.remove('no-scroll');
                scrollLock.show();
            }
        }
        this.modalService.close();
    };
    INDRASessionTimeoutModalComponent.prototype.INDRA_confirm = function () {
        var _this = this;
        /*
        // TODO check if these changes needs to be applied (from Sprint 8 merge)
        if (this.router.url.indexOf('sidebar') >= 0) {
            this.sidebarService.close();
        }
        this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
        this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(false));
        this.closeModal();
        this.sidebarService.isOpen.subscribe(value => {
            if (value === false) {
                if (this.isCorporate === true)
                    this.router.navigate(['/corporate'], { relativeTo: this.route });
                else
                    this.router.navigate(['/'], { relativeTo: this.route });
            }
        });
        */
        this.closeModal();
        this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
        this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(false));
        this.api.INDRA_createNewSession();
        this.sidebarService.closeSidebar();
        this.storageService.set('allow_navigate', 'true');
        this.INDRA_handleLogout();
        if (this.router.url !== '/booking') {
            this.api.hasToken.subscribe(function (res) {
                if (res) {
                    _this.router.navigateByUrl('/booking');
                }
            });
        }
        else {
            window.location.reload();
        }
    };
    INDRASessionTimeoutModalComponent.prototype.INDRA_handleLogout = function () {
        this.store.dispatch(new UserActions.PutLoggedInAction(false));
        this.store.dispatch(new UserActions.PutUserInfoAction(false));
        this.store.dispatch(new UserActions.PutCancelLogIn(false));
        this.storageService.remove('userData');
        this.storageService.remove('user_info');
        this.storageService.remove('prevSelectedLanguage');
    };
    return INDRASessionTimeoutModalComponent;
}(AbstractModalContentComponent));
export { INDRASessionTimeoutModalComponent };
